import React, { useState} from 'react';
import BannerSection from '../../../components/sections/NewsAndSearch/BannerSection';

const OurStoriesHeader = (props: any) => {
    const [HeadingSectionData, setHeadingSection] = useState<any>(props.data);

    return (
        <>
            <BannerSection data={HeadingSectionData} />
        </>
    );
}
export default OurStoriesHeader;
